module.exports = __webpack_public_path__ + "static/media/mosymLogo.656b215a.svg";